// extracted by mini-css-extract-plugin
module.exports = {"UserProfileButton":"UserProfileButton_UserProfileButton__1VyZC","LabelText":"UserProfileButton_LabelText__2xehS"};